export default __webpack_public_path__ + "static/media/library.0c05267d.jpg";